import { render, staticRenderFns } from "./PlaylistPage.vue?vue&type=template&id=0f4c186b&"
import script from "./PlaylistPage.vue?vue&type=script&lang=js&"
export * from "./PlaylistPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports